import ImageAlbumListPage from './ImageAlbumListPage';
import _ImageAlbumPage from './ImageAlbumPage';

export const ImageAlbumPage = _ImageAlbumPage;
export default ImageAlbumListPage;
